import { render, staticRenderFns } from "./PRs.vue?vue&type=template&id=9105aefe&"
import script from "./PRs.vue?vue&type=script&lang=js&"
export * from "./PRs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports